// eslint-disable-next-line no-restricted-imports
import {observe} from '@github/selector-observer'

observe('.js-octocaptcha-parent', function (form) {
  const formSubmit = form.querySelector<HTMLButtonElement>('.js-octocaptcha-form-submit')!

  // 'input' covers text inputs and 'change' covers select elements and checkboxes.
  form.addEventListener('input', () => toggleSubmitButton(form, formSubmit))
  form.addEventListener('change', () => toggleSubmitButton(form, formSubmit))
})

function toggleSubmitButton(form: Element, button: HTMLButtonElement) {
  if ((form as HTMLFormElement).checkValidity()) {
    button.disabled = false
  } else {
    button.disabled = true
  }
}
